import { PayloadAction } from "@reduxjs/toolkit";
import portalApi from "api/portalApi";
import { COMMON_ERROR } from "constants/error";
import { call, put, takeLatest } from "redux-saga/effects";
import { AxiosWithCommonResponse } from "types/response";
import { clearCertificate, getCertificate, saveCertificate } from "./certificateSlice";

function* fetchCertificate(action: PayloadAction<string>) {
  try {
    const response: AxiosWithCommonResponse = yield call(portalApi.lookupByRegistrationCode, action.payload);
    if (response?.data?.success) {
      yield put(saveCertificate(response.data.data));
    } else {
      yield put(clearCertificate());
    }
  } catch (error: any) {
    if (typeof window !== "undefined") {
      if (error?.response?.data?.name === COMMON_ERROR.NOT_FOUND.name) {
        window.location.replace("/lookup/404");
      }
    }
    yield put(clearCertificate());
  }
}

const certificateSaga = [takeLatest(getCertificate.type, fetchCertificate)];

export default certificateSaga;
